<template>
  <div class="modal fade show" aria-labelledby="moneyReceiptModalTitle" style="display: block; background: #1c1d1c33">
    <div class="modal-dialog modal-dialog-centered modal-lg" ref="modalRef">
      <div class="modal-content">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between px-1 my-1 align-item-center">
              <h1 class="mb-0">Money Receipt</h1>
              <button
                @click="onClickClose"
                type="button"
                class="btn-close"
                aria-label="Close"
              ></button>
            </div>
          </div>
        </div>

        <hr class="mt-0 mb-0">

        <div class="px-2 py-1">
          <div class="d-inline-block mb-1">
            <span> Patient: </span>
            <span> <strong>{{ patientName }}</strong> </span>
            <span class="ms-2"> IPD Admission No: </span>
            <span> <strong>{{ admissionNo }}</strong> </span>
          </div>

          <div class="row gy-1">
            <div class="col-12 col-sm-6">
              <label class="col-form-label">Receive Date</label>
              <input
                class="form-control"
                type="date"
                v-model="formData.receipt_date"
              />
            </div>

            <div class="col-12 col-sm-6">
              <label class="col-form-label">Receive In</label>
              <v-select
                v-model="formData.account_head_id"
                placeholder="Select Cash & Bank Account"
                class="w-100"
                :options="accountHeads"
                label="name"
                :reduce="(name) => name.id"
              />
            </div>

            <div class="col-12 col-sm-6">
              <label class="col-form-label">Receive Ref</label>
              <input
                type="text"
                class="form-control"
                v-model="formData.receipt_reference"
                placeholder="Reference"
              />
            </div>

            <div class="col-12 col-sm-6">
              <label class="col-form-label">Ref Date</label>
              <input
                class="form-control"
                type="date"
                v-model="formData.receipt_reference_date"
              />
            </div>

            <div class="col-12 col-sm-6">
              <label class="col-form-label">Advance Amount</label>
              <input
                type="number"
                class="form-control"
                v-model="formData.total_paid_amount"
                placeholder="Advance Amount"
              />
            </div>
          </div>

          <div class="d-flex gap-1 mt-2 mb-1">
            <button :disabled="saveLoading" @click="handleSubmit" class="btn btn-primary">Save</button>
            <button @click="onClickClose" class="btn btn-outline-secondary">Cancel</button>
          </div>
        </div>

        <Loader v-if="loading"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import {inject, onMounted, ref} from 'vue'
import {useRoute} from 'vue-router'
import handlePayment from '@/services/modules/payment'
import handlePurchase from '@/services/modules/purchase'
import handleHospital from '@/services/modules/hospital'
import useDate from '@/services/utils/day'
import Loader from '@/components/atom/LoaderComponent'

const props = defineProps({
  ipdRegisterId: {
    type: [String, Number],
    required: true
  }
})

const emit = defineEmits(['onClose', 'onSaved'])

const $route = useRoute()
const date = useDate()
const showError = inject('showError')
const showSuccess = inject('showSuccess')

const {fetchCashAndBank} = handlePayment()
const {storeAdvanceInvoice, fetchAccountReceivable} = handlePurchase()
const {fetchSingleNote} = handleHospital()

const companyId = $route.params.companyId
const companyQuery = `?company_id=${companyId}`
const loading = ref(false)
const saveLoading = ref(false)
const accountHeads = ref([])
const patientName = ref('')
const admissionNo = ref('')

const formData = ref({
  company_id: companyId,
  contact_profile_id: null,
  ipd_register_id: props.ipdRegisterId,
  receipt_date: date.currentDate(),
  receipt_reference: '',
  receipt_reference_date: '',
  account_head_id: null,
  account_receivable_id: null,
  total_paid_amount: 0,
  voucher_type: 'receipt_voucher',
  txn_type: 'invoice_receipt',
  is_pharmacy: 1,
  description: ''
})

const onClickClose = () => {
  emit('onClose')
}

const loadIpdRegister = async () => {
  await fetchSingleNote(companyQuery, props.ipdRegisterId).then(res => {
    if (!res.data) return;
    patientName.value = res.data.patient.full_name;
    admissionNo.value = res.data.admission_no;
    formData.value.contact_profile_id = res.data.patient.id;
  })
}

const loadAccountHeads = async () => {
  await fetchCashAndBank(companyId).then(res => {
    if (!res.status) return;
    accountHeads.value = res.data;
    if (res.data.length) formData.value.account_head_id = res.data[0].id;
  })
}

const loadAccountReceivable = async () => {
  await fetchAccountReceivable(companyQuery).then(res => {
    if (!res.status) return;
    if (res.data.length) formData.value.account_receivable_id = res.data[0].id;
  })
}

const handleSubmit = () => {
  if (!formData.value.total_paid_amount) return showError('Advance amount is required');
  if (!formData.value.account_head_id) return showError('Receive In account is required');
  saveLoading.value = true;
  formData.value.mop_account_head_id = formData.value.account_head_id;
  storeAdvanceInvoice({...formData.value, date: formData.value.receipt_date})
    .then(res => {
      saveLoading.value = false;
      if (!res.status) return showError(res.message);
      showSuccess(res.message);
      emit('onSaved');
    })
    .catch(err => {
      saveLoading.value = false;
      showError(err.response.data.message);
    })
}

onMounted(async () => {
  loading.value = true;
  await Promise.all([loadIpdRegister(), loadAccountHeads(), loadAccountReceivable()]);
  loading.value = false;
})
</script>
